import React from 'react';
import { Modal, Descriptions, Tag, Typography } from 'antd';
import { Equipment } from '../../types';

const { Title } = Typography;

interface EquipmentDetailsModalProps {
  visible: boolean;
  equipment: Equipment | null;
  onClose: () => void;
}

const EquipmentDetailsModal: React.FC<EquipmentDetailsModalProps> = ({
  visible,
  equipment,
  onClose,
}) => {
  if (!equipment) return null;

  return (
    <Modal
      title={<Title level={3}>{equipment.name}</Title>}
      open={visible}
      onCancel={onClose}
      footer={null}
      width={800}
    >
      <Descriptions bordered column={2}>
        <Descriptions.Item label="Category">
          <Tag color="blue">{equipment.category}</Tag>
        </Descriptions.Item>
        <Descriptions.Item label="Status">
          <Tag color="green">{equipment.status}</Tag>
        </Descriptions.Item>
        <Descriptions.Item label="Brand">{equipment.brand}</Descriptions.Item>
        <Descriptions.Item label="Model">{equipment.model}</Descriptions.Item>
        <Descriptions.Item label="Serial Number">{equipment.serialNumber}</Descriptions.Item>
        <Descriptions.Item label="Location">{equipment.location}</Descriptions.Item>
      </Descriptions>
    </Modal>
  );
};

export default EquipmentDetailsModal; 